<template>
  <div class="mt-10">
    <md-card>
      <md-card-expand>
        <md-card-actions md-alignment="space-between">
          <md-card-expand-trigger>
            <md-button class="expand-button-size"><strong @click="expandActivityLog()">Activity
                <span>({{ ask.activityLogLength }})</span></strong></md-button>
          </md-card-expand-trigger>
        </md-card-actions>
        <md-card-expand-content>
          <md-card-content class="comments">
            <div class="activity-log">
              <div v-for="(activity, index) in sortActivities" class="activity" :key="activity.action + index">
                <div v-if="!activity.recipient_email">
                  <b>{{ activity.when | momentDateUTC }} <span v-if="activity.memberName">- {{ activity.memberName
                  }}</span></b>
                  <p class="ask-description" v-if="activity.action === 'Tagged'">{{ activity.description.replace(/,/g,
                    ', ') }}</p>
                  <p class="ask-description" v-else-if="activity.description.match(/Responded with/)"
                    v-html="activity.description"></p>
                  <p class="ask-description" v-else>{{ activity.description }}</p>
                  <p class="ask-description">{{ activity.details }}</p>
                </div>
                <div v-else>
                  {{ activity.when | momentDateUTC }}:
                  {{ activity.memberName }}
                  <b>{{ activity.action }}</b><br> {{ activity.details }}
                  <br><span>Action: {{ activity.action_taken }}</span>
                  <br><span>Action Taken: </span>
                  <md-chip class="action-event"
                    :style="{backgroundColor: [activity.action_type == 'yes' ? 'lightgreen' : '#FC9A9A']}">{{ activity.action_type }}</md-chip>
                  <br>Sent To <span v-for="(email, index) in activity.recipient_email" :key="activity.action + index">{{
                    email }}</span>
                  <br>
                </div>
                <!--<md-divider></md-divider>-->
              </div>
            </div>
          </md-card-content>
        </md-card-expand-content>
      </md-card-expand>
    </md-card>
  </div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
export default {
  name: "ActivityLog",
  props: ["ask", "section", "analysis"],
  data() {
    	return {
    		api: new API(),
        sortActivities: []
      }
  },
  methods: {
    flattenTags(tagging) {
      // If tagging is null or undefined, return an empty array
      if (!tagging) return [];
      // If tagging is already an array, return it as-is
      if (Array.isArray(tagging)) {
        return tagging;
      } else {
        // If tagging is an object, get all its values
        return Object.values(tagging)
          .flatMap(val => Array.isArray(val) ? val : [val]);
      }
    },
    expandActivityLog: async function () {
      if (this.sortActivities.length === 0) {
        await this.api.get(`asks/${this.$route.params.ask_id}?call=activity`).then(async ask => {
          this.sortActivities = ask.data.activityLog;
          this.ask.activityLogLength = this.sortActivities.length;
        });
      }
    },
  }
};
</script>
<style>
.table-container {
  overflow-x: auto;
  margin-top: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 8px;
}

.feedback-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.feedback-table th, 
.feedback-table td {
  padding: 12px 16px;
  text-align: left;
}

.feedback-table thead {
  background-color: #f0f4f8;
}
</style>


// WEBPACK FOOTER //
// src/components/ActivityLog.vue